import { useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();

    let permission = to.matched.find((record) => record.meta.permission);
    if (
        typeof permission !== 'undefined' &&
        !userStore.userPermissions[permission.meta.permission]
    ) {
        next('/');
    } else {
        next();
    }
}
